import { RecipeId } from "@eatbetter/recipes-shared";
import { TBody } from "@eatbetter/ui-shared";
import { Link } from "react-router-dom";
import { AdminRecipesScreenIdNav } from "../screens/AdminRecipesScreen";

export const RecipeLink = (props: { id: RecipeId; newTab?: boolean }) => {
  return (
    <TBody>
      <Link
        to={AdminRecipesScreenIdNav.getPath(props.id)}
        {...(props.newTab ? { target: "_blank", rel: "noreferrer" } : {})}
      >
        {props.id}
      </Link>
    </TBody>
  );
};
